import { useTranslation } from 'react-i18next';

import { useNotificationAudience } from '../../../hooks/useNotificationAudience';
import { EnrollmentStatusFilters } from '../../molecules/EnrollmentStatusFilters';
import { ClassroomList } from '../ClassroomList';

/**
 * Etapa 1 do wizard de notificação — seleção de público.
 *
 * Exibe a lista paginada de turmas (com busca) e os filtros de status de matrícula.
 * Consome `useNotificationAudience` diretamente.
 */
export function NotificationAudienceStep() {
  const { t } = useTranslation('notification');

  const {
    enrollmentStatuses,
    isLoadingStatuses,
    selectedClassroomIds,
    selectedStatuses,
    toggleClassroom,
    selectPageClassrooms,
    toggleStatus,
    toggleAllStatuses,
  } = useNotificationAudience();

  return (
    <div className="flex flex-col gap-sm p-xxs">
      <div className="flex items-start justify-between gap-sm">
        <div>
          <h2 className="ts-heading-sm text-ctx-content-title">{t('wizard.audience.cardTitle')}</h2>
          <p className="ts-paragraph-xs text-ctx-content-title">
            {t('wizard.audience.cardSubtitle')}
          </p>
        </div>
      </div>

      <ClassroomList
        selectedIds={selectedClassroomIds}
        onToggle={toggleClassroom}
        onSelectPage={selectPageClassrooms}
      />

      <EnrollmentStatusFilters
        statuses={enrollmentStatuses}
        selectedIds={selectedStatuses}
        onToggle={toggleStatus}
        onSelectAll={toggleAllStatuses}
        isLoading={isLoadingStatuses}
      />
    </div>
  );
}
